import { CycleDetailPage } from '@/features/cycles/pages/CycleDetailPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/cycles/$cycleId')({
  component: CycleDetailPage,
});
